import { Heading } from '@purpur/library';
import styled from 'styled-components';

import { getPurpurSpacing } from '@telialt/common-theme/src/purpurSelectors';

export const ESimInfoSection = styled.section`
    padding: ${getPurpurSpacing('200')} 0 ${getPurpurSpacing('600')};
    display: flex;
    flex-direction: column;
    gap: ${getPurpurSpacing('200')};
`;

export const ESimInfoSectionTitle = styled(Heading)`
    margin-bottom: ${getPurpurSpacing('100')};
`;
